(function () {
  const keys = ['product', 'protein', 'meal', 'occasion'];
  function initHub(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-recipe-card]'));
    const controls = Object.fromEntries(keys.map(key => [key, root.querySelector('[data-filter="' + key + '"]')]));
    const count = root.querySelector('[data-result-count]');
    const active = root.querySelector('[data-active-filters]');
    const empty = root.querySelector('[data-empty-state]');
    const path = root.dataset.hubPath || location.pathname;
    const seen = new Set();
    cards.forEach(card => { if (seen.has(card.dataset.recipeId)) card.remove(); else seen.add(card.dataset.recipeId); });
    const uniqueCards = cards.filter(card => card.isConnected);
    function readURL() {
      const params = new URLSearchParams(location.search);
      keys.forEach(key => {
        const value = params.get(key) || '';
        controls[key].value = Array.from(controls[key].options).some(option => option.value === value) ? value : '';
      });
    }
    function apply(writeURL) {
      let visible = 0;
      const selected = Object.fromEntries(keys.map(key => [key, controls[key].value]));
      uniqueCards.forEach(card => {
        const match = keys.every(key => !selected[key] || (card.dataset[key] || '').split('|').includes(selected[key]));
        card.hidden = !match;
        if (match) visible++;
      });
      count.textContent = visible === 1 ? root.dataset.countOne : root.dataset.countMany.replace('__COUNT__', String(visible));
      empty.hidden = visible !== 0;
      active.replaceChildren();
      keys.forEach(key => {
        if (!selected[key]) return;
        const text = controls[key].selectedOptions[0].textContent;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = text + ' ×';
        button.setAttribute('aria-label', root.dataset.removeLabel.replace('__FILTER__', text));
        button.addEventListener('click', function () { controls[key].value = ''; apply(true); });
        active.append(button);
      });
      root.querySelectorAll('[data-clear-filters]').forEach(button => { if (button.closest('fieldset')) button.hidden = !keys.some(key => selected[key]); });
      const current = new URL(location.href);
      keys.forEach(key => { if (selected[key]) current.searchParams.set(key, selected[key]); else current.searchParams.delete(key); });
      if (writeURL) history.replaceState(null, '', current.pathname + current.search + current.hash);
      const target = path + current.search;
      uniqueCards.forEach(card => {
        const link = card.querySelector('[data-recipe-link]');
        if (!link.dataset.originalHref) link.dataset.originalHref = link.getAttribute('href');
        const url = new URL(link.dataset.originalHref, location.origin);
        url.searchParams.set('cs_hub_return', target);
        link.href = url.pathname + url.search;
      });
    }
    keys.forEach(key => controls[key].addEventListener('change', () => apply(true)));
    root.querySelectorAll('[data-clear-filters]').forEach(button => button.addEventListener('click', () => { keys.forEach(key => { controls[key].value = ''; }); apply(true); }));
    window.addEventListener('popstate', () => { readURL(); apply(false); });
    readURL(); apply(false);
    root.querySelector('[data-cs-filters]').hidden = false;
  }
  function initView(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const back = root.querySelector('[data-hub-back]');
    const returned = new URLSearchParams(location.search).get('cs_hub_return');
    if (returned) {
      try {
        const url = new URL(returned, location.origin);
        if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\/(?:recipes|pizza-recipes|partner-recipes)\/?$/.test(url.pathname)) back.href = url.pathname + url.search;
      } catch (_) {}
    }
    const photo = root.querySelector('[data-cs-print-photo]');
    if (photo) photo.addEventListener('change', () => document.body.classList.toggle('cs-include-print-photo', photo.checked));
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-cs-hub]')) initHub(scope);
    if (scope.matches && scope.matches('[data-cs-recipe-view]')) initView(scope);
    scope.querySelectorAll('[data-cs-hub]').forEach(initHub);
    scope.querySelectorAll('[data-cs-recipe-view]').forEach(initView);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
